module.exports = __webpack_public_path__ + "static/media/icon-x-button.6d19e68c.svg";